import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	text: {
		defaultMessage: 'Theme',
		id: 'atlassian-navigation.profile.menu.theme-switcher-item.trigger-button.text',
		description: 'Menu item to quickly open theme toggle menu',
	},
});
